import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import Button from "../components/Button";
import { words } from "../constants";

const Hero = () => {
  useGSAP(() => {
    const tl = gsap.timeline();

    tl.fromTo(
      ".hero-text h1",
      { y: 50, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.out",
      }
    )
      .fromTo(
        ".hero-text h1 span",
        { filter: "blur(5px)" },
        { filter: "blur(0px)", duration: 1 },
        "<"
      )
      .fromTo(
        ".hero-text p",
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 1 },
        "-=0.5"
      )
      .fromTo(
        ".cta-wrapper",
        { opacity: 0, scale: 0.95 },
        { opacity: 1, scale: 1, duration: 0.8 },
        "-=0.6"
      );
  }, []);

  return (
    <section id="hero" className="relative overflow-hidden w-full h-screen">
      {/* Spline background */}
      <div className="absolute inset-0 z-0">
        <iframe
          src="https://my.spline.design/glasswave-27BQJZj4CjIbU2z67SWvJtRT/"
          frameBorder="0"
          width="100%"
          height="100%"
          className="w-full h-full"
          allow="autoplay; fullscreen"
        />
      </div>

      {/* Content over Spline */}
      <div className="hero-layout relative z-10 flex flex-col xl:flex-row items-center justify-between px-5 md:px-20 h-full">
        {/* LEFT */}
        <header className="flex flex-col gap-7 max-w-4xl">
          <div className="hero-text text-white">
            <h1>
              <div className="lg:block hidden">
                Je transforme vos
                <span className="slide">
                  <span className="wrapper">
                    {words.map((word, index) => (
                      <span
                        key={index}
                        className="flex items-center md:gap-3 gap-1 pb-2"
                      >
                        <img
                          src={word.imgPath}
                          alt="person"
                          className="xl:size-12 md:size-10 size-7 md:p-2 p-1 rounded-full bg-white-50"
                        />
                        <span className="glow-text">{word.text}</span>
                      </span>
                    ))}
                  </span>
                </span>
              </div>
              <div className="block lg:hidden">Je transforme 
                <span className="block">vos
                  <span className="slide">
                    <span className="wrapper">
                      {words.map((word, index) => (
                        <span
                          key={index}
                          className="flex items-center md:gap-3 gap-1 pb-2"
                        >
                          <img
                            src={word.imgPath}
                            alt="person"
                            className="xl:size-12 md:size-10 size-7 md:p-2 p-1 rounded-full bg-white-50"
                          />
                          <span className="glow-text">{word.text}</span>
                        </span>
                      ))}
                    </span>
                  </span>
                </span>
              </div>
              en expériences web<br/>
              qui marquent les esprits
            </h1>
          </div>

          <p className="text-white-50 md:text-xl relative z-10 pointer-events-none">
            Salut ! Moi c’est Goulven, développeur web FullStack.<br/> 
            Je suis sportif et gameur dans l'âme. J'adore apprendre de nouvelles choses dans des domaines variés.
            Je m'intéresse énormément à la modélisation 3D, le montage vidéo, la création de contenues et l'IA.
          </p>

          <Button
            text="Voir mes projets"
            className="md:w-80 md:h-16 w-80 h-16"
            id="counter"
          />
        </header>

        {/* You can remove the right spline container if already used in background */}
      </div>
    </section>

  );
};

export default Hero;
